import { connect } from 'react-redux';

import { clearEmptyFilterClauses, scrollToActiveElement } from '../../../utils/compound';
import {
  getSelectedSegment,
  getTenantId,
  getUpdatingSegment,
  getUpdatingSegmentId,
  isSegmentExists,
} from '../../../reducers/analyticsApp';
import { cancelUpdateSegment, createSegment, updateSegment } from '../../../actions/segment';
import CompoundUpdatePane from '../../../components/compound/update/Pane';

const mapStateToProps = (state) => ({
  item: getUpdatingSegment(state),
  selectedItem: getSelectedSegment(state),
  id: getUpdatingSegmentId(state),
  tenantId: getTenantId(state),
  isExists: (segment) => isSegmentExists(state, segment),
  location: 'segments',
});

const mapDispatchToProps = {
  onCancel: cancelUpdateSegment,
  create: createSegment,
  update: updateSegment,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onCancel: () => {
    dispatchProps.onCancel();
    const urlId = stateProps.item?.id || stateProps.selectedItem?.id;
    const path = urlId
      ? `/${stateProps.tenantId}/segments/execution/${urlId}`
      : `/${stateProps.tenantId}/segments`;
    ownProps.navigate(path);
  },
  onSave: (item, id) => {
    const segment = clearEmptyFilterClauses(item);
    const { name, steps } = item;
    const isAllStepsWithEvent = steps.every((step) => step.event);
    const isValidSegment = !!name && isAllStepsWithEvent;
    const onSave = () =>
      stateProps.isExists(segment)
        ? dispatchProps.update(segment, id)
        : dispatchProps.create(segment);

    if (!isValidSegment) {
      ownProps.setShowNotValidFields(true);
    }

    if (isValidSegment) {
      onSave().then((response) => {
        ownProps.navigate(`/${stateProps.tenantId}/segments/execution/${response.segment.id}`);
        scrollToActiveElement();
      });
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CompoundUpdatePane);
